import type { QuoteItem } from '../pages/cpq-v2/state/types';

/** Read only media bound to the exact validated replacement identity. */
export function readReplacementTargetMedia(
  value: unknown,
  targetId: unknown,
): QuoteItem['replacementTargetMedia'] {
  if (!value || typeof value !== 'object' || Array.isArray(value))
    return undefined;
  const media = value as Record<string, unknown>;
  if (
    typeof targetId !== 'string' ||
    !targetId ||
    typeof media.targetRevisionId !== 'string' ||
    !media.targetRevisionId ||
    media.version !== 'replacement-target-media-v1' ||
    media.targetId !== targetId ||
    !Array.isArray(media.imageObjectIds) ||
    !media.imageObjectIds.every(
      (id) => typeof id === 'string' && id.length > 0,
    ) ||
    new Set(media.imageObjectIds).size !== media.imageObjectIds.length ||
    (media.primaryImageObjectId !== null &&
      !media.imageObjectIds.includes(media.primaryImageObjectId))
  )
    return undefined;
  return {
    version: 'replacement-target-media-v1',
    targetId,
    targetRevisionId: media.targetRevisionId,
    imageObjectIds: [...media.imageObjectIds] as string[],
    primaryImageObjectId: media.primaryImageObjectId as string | null,
  };
}
